import { useState, type FC, type ReactNode } from 'react';

import { Tooltip } from 'dibs-elements/exports/Tooltip';
import InfoCircle from 'dibs-icons/exports/InfoCircle';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import cn from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    descriptionTerm: ReactNode;
    children: ReactNode;
    tooltipText?: ReactNode;
    className?: string;
};

export const SbSharedMarketTrendsPriceStatsDescription: FC<Props> = ({
    descriptionTerm,
    children,
    tooltipText,
    className,
}) => {
    const { isDesktop } = useServerVarsContext();
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    return (
        <div className={className}>
            <dt
                className={cn(
                    dibsCss.sassyFontBodySmallHeavy,
                    dibsCss.flex,
                    dibsCss.flexRow,
                    dibsCss.itemsStart
                )}
            >
                {descriptionTerm}
                {tooltipText && (
                    <div
                        className={cn(
                            dibsCss.flex,
                            dibsCss.itemsCenter,
                            dibsCss.mlXxsmall,
                            dibsCss.relative,
                            dibsCss.cursorPointer
                        )}
                        {...(isDesktop
                            ? {
                                  onMouseEnter: () => setIsTooltipVisible(true),
                                  onMouseLeave: () => setIsTooltipVisible(false),
                              }
                            : {
                                  onClick: () => setIsTooltipVisible(prev => !prev),
                              })}
                    >
                        {isTooltipVisible ? (
                            <InfoCircle variation="20Filled" />
                        ) : (
                            <InfoCircle variation="20" />
                        )}
                        <Tooltip
                            isVisible={isTooltipVisible}
                            direction="top"
                            align="center"
                            type="medium"
                            {...(isDesktop
                                ? {}
                                : {
                                      closeOnOutsideClick: true,
                                      onClose: () => setIsTooltipVisible(false),
                                  })}
                        >
                            <div className={dibsCss.whitespaceNormal}>{tooltipText}</div>
                        </Tooltip>
                    </div>
                )}
            </dt>
            <dd
                className={cn(
                    isDesktop ? dibsCss.sassyFontHeaderLarge : dibsCss.sassyFontHeaderMedium,
                    dibsCss.mtXsmall,
                    dibsCss.ml0
                )}
            >
                {children}
            </dd>
        </div>
    );
};
